'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Stack, Typography, Box } from '@mui/material';
import theme from '@/theme/theme';
import Footer from '@/components/layout/footer';
import SideTabbedButton from "@/components/generic/SideTabbedButton";
import contactPageBg from "@/assets/images/contactPage/contactPageBg.svg?url";
import arrow from "@/assets/images/icons/arrow.webp";

export default function NotFound() {
    return (
        <Stack width="100%" alignItems="center" sx={{ bgcolor: '#0B0B0B', minHeight: '100vh', justifyContent: 'space-between' }}>
            <Box sx={{
                width: "100%",
                height: { xs: "55vh", lg: "65vh" },
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderBottomLeftRadius: { xs: '24px', lg: '48px' },
                borderBottomRightRadius: { xs: '24px', lg: '48px' },
                overflow: "hidden"
            }}>
                <Box sx={{ display: { xs: "none", lg: "block" }, position: "absolute", inset: 0, zIndex: 0 }}>
                    <Image 
                        src={contactPageBg} 
                        alt="404 background" 
                        fill 
                        style={{ objectFit: "cover", objectPosition: "center" }}
                        priority 
                    />
                </Box>
                <Box sx={{ display: { xs: "block", lg: "none" }, position: "absolute", inset: 0, zIndex: 0 }}>
                    <Image 
                        src={contactPageBg} 
                        alt="404 background" 
                        fill 
                        style={{ objectFit: "cover", transform: "scaleX(-1)", objectPosition: "center" }} 
                        priority 
                    />
                </Box>
                <Box sx={{
                    display: { xs: "block", lg: "none" },
                    position: "absolute", 
                    bottom: 0, 
                    left: 0, 
                    width: "100%", 
                    height: "15vh",
                    background: "linear-gradient(to top, #0B0B0B 0%, transparent 100%)",
                    zIndex: 1
                }} />
                <Stack alignItems="center" gap={3} textAlign="center" sx={{ position: "relative", zIndex: 2, px: 2 }}>
                    <Typography 
                        variant="h1" 
                        className="chno"
                        fontWeight={300} 
                        sx={{ 
                            fontSize: { xs: '4.5rem !important', md: '7.5rem !important' },
                            color: 'white',
                            lineHeight: 1.5,
                        }}
                    >
                        404
                    </Typography>

                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: theme.palette.text.secondary, 
                            maxWidth: '400px', 
                            fontWeight: 300,
                            lineHeight: 1.6,
                            mb: 2,
                            fontSize: { xs: '0.9rem', md: '1rem' }
                        }}
                    >
                        Looks like you&apos;ve reached a page <br /> that&apos;s currently under development or doesn&apos;t exist.
                    </Typography>
                    <Box sx={{ cursor: 'pointer' }}>
                        <Link href="/" style={{ textDecoration: 'none', display: 'block' }}>
                            <SideTabbedButton paddingX={18} hoverShiftX={1.5} hoverShiftY={-1}>
                                <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
                                    <Typography component="span" variant="h6" sx={{ whiteSpace: "nowrap", display: "inline-block" }}>
                                        Main page
                                    </Typography>
                                    <span className="arrow-clip">
                                        <span className="arrow-slide">
                                            <Image src={arrow} alt="arrow animation" width={20} height={20} style={{ display: "block" }} />
                                        </span>
                                    </span>
                                </Stack>
                            </SideTabbedButton>
                        </Link>
                    </Box>
                </Stack>
            </Box>
            <Stack width="100%" alignItems="center" position="relative" sx={{
                borderTop: `1px solid ${theme.palette.brand.border1.main}`,
                mt: { xs: 6, lg: 8 }
            }}>
                <Footer />
            </Stack>
        </Stack>
    );
}